import createClient from 'openapi-fetch';

import type { components, paths } from './generated/schema.js';

export { clearSessionCsrfCookies, readSessionCsrfToken } from './csrf.js';

export type ApiPaths = paths;
export type ApiComponents = components;

export interface ApiClientOptions {
  baseUrl: string;
  csrfToken?: string;
}

/**
 * Create the only supported browser transport for the server-authored API.
 * The CSRF token is session-bound and intentionally held in memory by callers.
 */
export function createApiClient({ baseUrl, csrfToken }: ApiClientOptions) {
  return createClient<paths>({
    baseUrl,
    credentials: 'include',
    headers: csrfToken === undefined ? undefined : { 'X-CSRF-Token': csrfToken },
  });
}
